<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>员工模块</el-breadcrumb-item>
            <el-breadcrumb-item>员工列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div>
      <el-form :inline="true"
               labelPosition="left"
               :model="employee"
               class="el-form">
        <el-form-item label="员工姓名："
                      class="el-form-item">
          <el-input v-model="employee.name"
                    placeholder="请输入员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="员工电话:">
          <el-input v-model="employee.phone"
                    placeholder="请输入员工电话"></el-input>
        </el-form-item>
        <el-form-item label="在职状态">
          <el-select v-model="employee.state"
                     placeholder>
            <el-option label="在职"
                       value="1"></el-option>
            <el-option label="离职"
                       value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="employee.deptId"
                     clearable
                     placeholder>
            <el-option v-for="item in deptList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="add">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table :data="tableData"
                border
                class="el-table">
        <el-table-column prop="username"
                         label="登陆账号"
                         width="120"></el-table-column>
        <el-table-column prop="name"
                         label="姓名"
                         width="100"></el-table-column>
        <el-table-column prop="six"
                         label="性别"
                         width="80"></el-table-column>
        <el-table-column prop="tel"
                         label="电话"
                         width="120"></el-table-column>
        <el-table-column prop="deptName"
                         label="部门"
                         width="120"></el-table-column>
        <el-table-column prop="address"
                         label="地址"
                         width="300"></el-table-column>
        <el-table-column prop="state"
                         label="在职状态"
                         width="100"></el-table-column>
        <el-table-column fixed="right"
                         label="操作">
          <template slot-scope="scope">
            <el-button @click="goDetails(scope.row)"
                       type="text"
                       size="small">详情</el-button>
            <el-button @click="employeeWorkload(scope.row)"
                       type="text"
                       size="small">工作量查看</el-button>
            <el-button @click="quitClick(scope.row)"
                       type="text"
                       :disabled="scope.row.states == 1 ? false : true"
                       size="small">离职</el-button>
            <el-button @click="changePassward(scope.row)"
                       type="text"
                       :disabled="scope.row.states == 1 ? false : true"
                       size="small">重置密码</el-button>
            <el-button @click="reentryClick(scope.row)"
                       type="text"
                       :disabled="scope.row.states == 2 ? false : true"
                       size="small">重新入职</el-button>
            <!-- <el-button @click="del(scope.row)"
                       type="text"
                       size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-dialog title="修改密码"
                 :visible.sync="centerDialogVisible"
                 center
                 ref="ruleForm"
                 label-width="40px">
        <el-form :model="password">
          <el-form-item label="新密码:"
                        :label-width="formLabelWidth">
            <el-input v-model="password.new"
                      placeholder="请输入新密码"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:"
                        :label-width="formLabelWidth">
            <el-input v-model="password.newtow"
                      placeholder="请再次输入新密码"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="changePasswardBack">取 消</el-button>
          <el-button type="primary"
                     @click="changePasswardOK">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-pagination background
                     @current-change="handleCurrentChange"
                     layout="total, prev, pager, next"
                     :total="totalCount"
                     :page-size="pageSize"
                     :page-count="pageTotal"></el-pagination>
    </div>
  </div>
</template>
<script>
import { userSel, userMod, userDel, userResetPass } from "@/api/uesr";
import { getUserStates, getUserGender } from "@/util/enum";
import { deptSel } from "@/api/department";
import moment from "moment";
export default {
  data () {
    return {
      employee: {
        name: "",
        phone: "",
        state: "1",
        deptId: ""
      },
      changePasswardUser: {},
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      centerDialogVisible: false,
      deptList: [],
      password: {
        new: "",
        newtow: ""
      },
      formLabelWidth: "120px"
    };
  },
  mounted () {
    this.getDeptList();
    this.getUserlist();
  },
  methods: {
    search () {
      this.pageNum = 1;
      this.getUserlist();
    },
    add () {
      this.$router.push("/home/enterprise/personnel/add");
    },
    quitClick (row) {
      if (this.isgoin(row.states)) {
        return;
      }
      if (row.id == localStorage.getItem("user_id")) {
        this.$message({
          type: "error",
          message: "自己不能离职自己！"
        });
        return;
      }
      this.$confirm("此操作将使此员工离职, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = row;
          params.states = 2;
          userMod(params)
            .then(res => {
              if (res.count == 1) {
                this.$message({
                  type: "success",
                  message: "离职成功!"
                });
                this.search();
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    reentryClick (row) {
      this.$confirm("此操作将使此员工重新入职, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = row;
          params.states = 1;
          userMod(params)
            .then(res => {
              if (res.count == 1) {
                this.$message({
                  type: "success",
                  message: "重新入职成功!"
                });
                this.search();
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    changePassward (row) {
      this.changePasswardUser = row;
      this.centerDialogVisible = true;
    },
    goDetails (row) {
      this.$router.push({ path: "details", query: row });
    },
    employeeWorkload (row) {
      if (this.isgoin(row.states)) {
        return;
      }
      this.$router.push({
        path: "employeeWorkload",
        query: {
          id: row.id,
          staffName: row.name,
          tel: row.tel,
          month: moment(new Date()).format("YYYY-MM")
        }
      });
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getUserlist();
    },
    del (row) {
      if (row.id == localStorage.getItem("user_id")) {
        this.$message({
          type: "error",
          message: "自己不能删除自己！"
        });
        return;
      }
      this.$confirm("是否删除员工" + row.name + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = {
            id: row.id,
            username: row.username
          };
          userDel(params)
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    getUserlist () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        name: this.employee.name,
        tel: this.employee.phone,
        states: this.employee.state,
        deptId: this.employee.deptId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      userSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.six = getUserGender(element.gender);
            element.state = getUserStates(element.states);
            this.tableData.push(element);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    changePasswardBack () {
      this.changePasswardUser = {};
      this.centerDialogVisible = false;
    },
    changePasswardOK () {
      if (this.password.new.length < 6) {
        this.$message.error("请输入6位以上密码");
        return;
      } else if (this.password.newtow != this.password.new) {
        this.$message.error("两次输入密码不一致");
        return;
      } else {
        const params = {
          id: this.changePasswardUser.id,
          pass: this.password.new
        };
        userResetPass(params)
          .then(() => {
            this.$message({
              type: "success",
              message: "密码修改成功"
            });
            this.changePasswardBack();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    isgoin (states) {
      if (states == 2) {
        this.$message({
          type: "warning",
          message: "员工已离职"
        });
        return true;
      } else {
        return false;
      }
    },
    getDeptList () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        states: 1,
        pageNum: 1,
        pageSize: 500
      };
      deptSel(params)
        .then(res => {
          this.deptList = [];
          res.gridData.forEach(element => {
            //element.state = getBatchStates(element.progress);
            const deptData = {
              value: element.id,
              label: element.name
            };
            this.deptList.push(deptData);
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-form {
  padding: 10px;
}
.el-form-item {
  float: left;
}
.el-table {
  widows: 100%;
}
.el-form-item {
  float: inherit;
}
</style>
